import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {lastValueFrom, Observable, Subject} from 'rxjs';
import {DeliveryTourService} from "@iw-shop/delivery-tour/services/delivery-tour.service";
import {debounceTime, take, takeUntil} from "rxjs/operators";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ApiDeliveryTour} from "@api/delivery-tours";
import {ShoppingCartService} from "@iw-shop/shopping-cart/services/shopping-cart.service";
import {updateShoppingCartSuccess} from "@store/actions/shopping-cart.action";
import {setNotification} from "@store/actions/global.actions";
import {
    ApiShoppingCartsSetRequest,
    ApiShoppingCartsSetResponse,
    ApiShoppingCartsUpdateResponse
} from "@api/shopping-carts";
import {ApiDeliveryBlockedDays} from "@api/delivery-blocked-days";
import {HTTPQueue} from "@iw-shop/core/classes/http-queue";


@Component({
    selector: 'iw-shop-delivery-tour-date-and-period-selection',
    standalone: false,
    templateUrl: './delivery-tour-date-and-period-selection.component.html',
    styleUrls: ['./delivery-tour-date-and-period-selection.component.scss']
})
export class DeliveryTourDateAndPeriodSelectionComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() isErrorOnDeliveryDate: boolean = false;
    @Input() isErrorOnDeliveryPeriod: boolean = false;

    @Output() isDeliveryDate = new EventEmitter<boolean>();
    @Output() isDeliveryPeriod = new EventEmitter<boolean>();
    @Output() isValid = new EventEmitter<boolean>();
    @Output() onSelectDeliveryTour = new EventEmitter<ApiDeliveryTour>();
    @Output() onChangeDeliveryDate = new EventEmitter<string>();
    @Output() onChangeDeliveryPeriod = new EventEmitter<string>();


    _isDeliveryDate: boolean = false;
    _isDeliveryPeriod: boolean = false;

    form: FormGroup;
    lastDeliveryDate?: any;
    lastDeliveryPeriod?: any;

    destroy$: Subject<boolean> = new Subject<boolean>();

    selectedDeliveryTourId?: string;

    deliveryPeriods: string[] = [];

    showBlockedDays: boolean = false;
    showBlockedDaysFromMonth = new Date().getMonth()
    showBlockedDaysFromYear = new Date().getFullYear()

    minDate: Date;

    disabledDates: Date[] = [];
    disabledDays: number[] = [];


    constructor(
        private store: Store<AppState>,
        public deliveryTourService: DeliveryTourService,
        protected fb: FormBuilder,
        private httpQueue: HTTPQueue,
        protected shoppingCartService: ShoppingCartService) {
        this.form = this.fb.group(
            {
                deliveryDate: this.fb.control(''),
                deliveryPeriod: this.fb.control('')
            }
        );
        this.minDate = new Date();

    }

    ngOnInit(): void {
        this.deliveryTourService.getSelectedDeliveryTour()
            .pipe(
                takeUntil(this.destroy$),
                debounceTime(500)
            ).subscribe(
            {
                next: () => {

                    const selectedDeliveryTour = this.deliveryTourService.getSelectedDeliveryTour().value;

                    if (selectedDeliveryTour) {
                        this.setDisabledDays();
                        this.setDisabledDates();
                        // Erster Aufruf mit ausgewählter Tour
                        if (!this.selectedDeliveryTourId) {
                            this.setTourByShoppingCart();
                            this.deliveryPeriods = this.deliveryTourService.getDeliveryPeriods();
                            this.setDeliveryDateAndPeriodValidation();
                        }
                        if (this.selectedDeliveryTourId &&
                            selectedDeliveryTour?.id != this.selectedDeliveryTourId
                        ) {
                            this.resetFormAndDeliveryTourDay();
                            this.saveTourInShoppingCart(false).then();
                            this.setDeliveryDateAndPeriodValidation();
                        }
                        this.selectedDeliveryTourId = selectedDeliveryTour?.id;
                    } else {
                        this.setDeliveryDateAndPeriodValidation();
                    }
                }
            }
        );

        this.form.valueChanges.pipe(
            takeUntil(this.destroy$)
        ).subscribe(
            (param) => {

                this.deliveryTourService.setOrderDateInMilliseconds(new Date().getTime());
                let deliveryDate = new Date(param['deliveryDate']);
                deliveryDate.setHours(23, 59, 59);
                this.deliveryTourService.setDeliveryDateInMilliseconds(deliveryDate.getTime())
                this.deliveryTourService.setSelectedDeliveryTourDay();
                this.deliveryTourService.getDeliveryNotes();
                this.deliveryPeriods = this.deliveryTourService.getDeliveryPeriods();
                this.setDeliveryDateAndPeriodValidation();

                if (param['deliveryDate'] !== this.lastDeliveryDate) {
                    this.form.get('deliveryPeriod')?.setValue('', {emitEvent: false});
                    this.onChangeDeliveryPeriod.emit('');
                    this.onChangeDeliveryDate.emit(param['deliveryDate']);
                }
                if (param['deliveryPeriod'] !== this.lastDeliveryPeriod) {
                    this.form.get('deliveryPeriod')?.setValue(param['deliveryPeriod'], {emitEvent: false});
                    this.onChangeDeliveryPeriod.emit(param['deliveryPeriod']);
                }

                // Alle Änderungen in der shoppingCart speichern
                let dateDeliveryDate = new Date(param['deliveryDate']);
                let dateDeliveryDateLast = new Date(this.lastDeliveryDate);
                if (
                    (
                        param['deliveryDate'] !== '' &&
                        dateDeliveryDate.getTime() !== dateDeliveryDateLast.getTime()
                    )

                    ||
                    (
                        param['deliveryPeriod'] !== this.lastDeliveryPeriod

                    )
                ) {
                    this.saveTourInShoppingCart(false).then(() => {
                    });

                }
                this.lastDeliveryDate = param['deliveryDate'];
                this.lastDeliveryPeriod = param['deliveryPeriod'];

            }
        )
    }

    ngAfterViewInit() {


    }

    setBlockedDaysFromMonthAndYear(event: any) {
        this.showBlockedDaysFromMonth = event.month - 1;
        this.showBlockedDaysFromYear = event.year;
    }

    resetFormAndDeliveryTourDay() {
        this.form.get('deliveryDate')?.setValue('');
        this.form.get('deliveryPeriod')?.setValue('');
        this.deliveryTourService.resetDeliveryTourDay();
        this.lastDeliveryDate = undefined;
        this.lastDeliveryPeriod = undefined;
        this.showBlockedDaysFromMonth = new Date().getMonth()
        this.showBlockedDaysFromYear = new Date().getFullYear()
    }

    setDeliveryDateAndPeriodValidation() {
        let deliveryTour = this.deliveryTourService.getSelectedDeliveryTour().value;
        // Keine Tour ausgewählt
        if (!deliveryTour) {
            this._isDeliveryDate = false;
            this.isDeliveryDate.emit(false);
            this._isDeliveryPeriod = false;
            this.isDeliveryPeriod.emit(false);
        } else {
            this._isDeliveryDate = true;
            this.isDeliveryDate.emit(true);
            if (this.deliveryPeriods.length > 0) {
                this._isDeliveryPeriod = true;
                this.isDeliveryPeriod.emit(true);
            } else {
                this._isDeliveryPeriod = false;
                this.isDeliveryPeriod.emit(false);
            }
        }
    }

    getBlockedDaysFromYearAndMonth(): ApiDeliveryBlockedDays[] {
        let blockedDays: ApiDeliveryBlockedDays[] = [];
        let today = new Date();
        this.deliveryTourService.getBlockedDays().map(
            blockedDay => {
                if (
                    (
                        (
                            new Date(blockedDay.from).getFullYear() == this.showBlockedDaysFromYear &&
                            new Date(blockedDay.from).getMonth() == this.showBlockedDaysFromMonth
                        ) ||
                        (
                            new Date(blockedDay.to).getFullYear() == this.showBlockedDaysFromYear &&
                            new Date(blockedDay.to).getMonth() == this.showBlockedDaysFromMonth
                        )
                    ) &&
                    new Date(blockedDay.to) >= today
                ) {
                    blockedDays.push(blockedDay)
                }
            }
        );
        return blockedDays;
    }

    setDisabledDates() {
        let startDate = new Date();
        let endDate = new Date(); // Assuming end date is after one year.
        endDate.setFullYear(startDate.getFullYear() + 1);

        let dates: Date[] = [];
        for (let dt = startDate; dt <= endDate; dt.setDate(dt.getDate() + 1)) {
            let exceptionFound = false;

            dt.setHours(23, 59, 58);

            let blockedDay = this.deliveryTourService.getBlockedDay(new Date(dt));
            if (blockedDay) {
                exceptionFound = true;
            }
            let deliveryTour = this.deliveryTourService.getSelectedDeliveryTour().value;
            if (deliveryTour && !this.deliveryTourService.isDeliveryTour(deliveryTour,
                {deliveryDateInMilliseconds: dt.getTime(), day: dt.getDay()})) {
                exceptionFound = true;
            }

            if (exceptionFound) {
                dates.push(new Date(dt));
            }
        }

        this.disabledDates = dates;
    }

    setDisabledDays() {
        let deliveryTour = this.deliveryTourService.getSelectedDeliveryTour().value;
        this.disabledDays = [];
        if (deliveryTour) {
            if (!deliveryTour.days.sunday.available) {
                this.disabledDays.push(0);
            }
            if (!deliveryTour.days.monday.available) {
                this.disabledDays.push(1);
            }
            if (!deliveryTour.days.tuesday.available) {
                this.disabledDays.push(2);
            }
            if (!deliveryTour.days.wednesday.available) {
                this.disabledDays.push(3);
            }
            if (!deliveryTour.days.thursday.available) {
                this.disabledDays.push(4);
            }
            if (!deliveryTour.days.friday.available) {
                this.disabledDays.push(5);
            }
            if (!deliveryTour.days.saturday.available) {
                this.disabledDays.push(6);
            }
        }
    }

    setTourByShoppingCart() {
        this.lastDeliveryPeriod = '';
        this.store.select(state => state.shoppingCart)
            .pipe(take(1))
            .subscribe(
                r => {

                    if (r.deliveryDate &&
                        this.deliveryTourService.getSelectedDeliveryTour().value) {
                        let deliveryDate = new Date(r.deliveryDate);
                        deliveryDate.setHours(23, 59, 59);
                        this.lastDeliveryDate = new Date(deliveryDate);
                        this.form.get('deliveryDate')?.setValue(new Date(deliveryDate));
                        /*console.log('setTourByShoppingCart', new Date(deliveryDate));*/
                        this.showBlockedDaysFromYear = new Date(deliveryDate).getFullYear();
                        this.showBlockedDaysFromMonth = new Date(deliveryDate).getMonth();
                        this.deliveryTourService.setDeliveryDateInMilliseconds(new Date(deliveryDate).getTime())
                        this.deliveryTourService.setSelectedDeliveryTourDay();
                        this.deliveryPeriods = this.deliveryTourService.getDeliveryPeriods();
                        this.onChangeDeliveryDate.emit(r.deliveryDate);
                    }

                    if (r.deliveryPeriod &&
                        r.deliveryPeriod != '' &&
                        this.deliveryTourService.getSelectedDeliveryTour().value) {
                        this.lastDeliveryPeriod = r.deliveryPeriod;
                        this.form.get('deliveryPeriod')?.setValue(r.deliveryPeriod);
                        this.onChangeDeliveryPeriod.emit(r.deliveryPeriod);
                    }
                    if (r.deliveryDate) {
                        let date = new Date(r.deliveryDate);
                        let isShoppingCartDateInvalid = false;
                        // Das gespeicherte Datum liegt in der Vergangenheit oder ist ein Datum was deaktiviert wurde
                        if (date <= new Date()) {
                            isShoppingCartDateInvalid = true;
                        }
                        this.disabledDates.map(x => {
                            let xString = `${x.getFullYear()}${x.getMonth()}${x.getDate()}`;
                            let dateString = `${date.getFullYear()}${date.getMonth()}${date.getDate()}`;
                            if (xString == dateString) {
                                isShoppingCartDateInvalid = true;
                            }
                        })
                        // Der Taas gespeicherte Datum liegt in der Vergangenheit oder ist ein Datum was deaktiviert wurde
                        if (this.disabledDays.includes(date.getDay())) {
                            isShoppingCartDateInvalid = true;
                        }
                        if (isShoppingCartDateInvalid) {
                            console.log('isShoppingCartDateInvalid true > reset');
                            this.resetFormAndDeliveryTourDay()
                        }
                    }
                    this._isValid();
                }
            );
    }

    _isValid(): boolean {
        let valid: boolean = true;
        let deliveryDate = this.form.get('deliveryDate')?.value ?? '';
        let deliveryPeriod = this.form.get('deliveryPeriod')?.value ?? '';
        if (this._isDeliveryDate &&
            deliveryDate.length == 0) {
            valid = false;
        }
        if (this._isDeliveryPeriod &&
            deliveryPeriod.length == 0) {
            valid = false;
        }
        this.isValid.emit(valid);
        return valid;
    }

    async saveTourInShoppingCart(refreshCart: boolean) {
        let id: string = '', token: string = '', sumBeforeChangeDeliveryDate: number = 0,
            countBeforeChangeDeliveryDate: number = 0;
        this.store
            .select(state => state.shoppingCart)
            .pipe(
                take(1)
            )
            .subscribe(
                r => {
                    if (r.id) {
                        id = r.id;
                        token = r.token;
                        sumBeforeChangeDeliveryDate = r.sum.total.grossTotal;
                        countBeforeChangeDeliveryDate = r.count.articles.items + r.count.dynamicArticles.items;
                    }
                }
            );

        let data: Partial<ApiShoppingCartsSetRequest['params']['data']> = {};
        data.deliveryDate = null;
        data.deliveryPeriod = null;
        if (this.form.get('deliveryDate')?.value) {
            data.deliveryDate = this.form.get('deliveryDate')?.value;
        }
        if (this.form.get('deliveryPeriod')?.value) {
            data.deliveryPeriod = this.form.get('deliveryPeriod')?.value;
        }
        let request: Observable<ApiShoppingCartsSetResponse | ApiShoppingCartsUpdateResponse> = this.shoppingCartService.setShoppingCart(
            'deliveryTourDateAndPeriod.saveTourInShoppingCart()#1',
            {
                data
            }
        )
        await lastValueFrom(this.httpQueue.invoke<ApiShoppingCartsSetResponse | ApiShoppingCartsUpdateResponse>(
                request
            )
        ).then(
            r => {
                if (r.result?.shoppingCarts.data) {
                    this.store.dispatch(updateShoppingCartSuccess({
                        shoppingCart: r.result.shoppingCarts.data,
                        notifications: r.result.shoppingCarts.notifications ?? []
                    }));
                }
            }
        );

        if (refreshCart) {
            this.httpQueue.invoke<ApiShoppingCartsUpdateResponse>(
                this.shoppingCartService.refreshShoppingCartArticles('deliveryTourDateAndPeriod.saveTourInShoppingCart()#2', undefined, this.form.get('deliveryDate')?.value)
            )
                .subscribe(
                    r => {
                        if (r.result?.shoppingCarts.data) {
                            this.store.dispatch(updateShoppingCartSuccess({
                                shoppingCart: r.result?.shoppingCarts.data,
                                notifications: r.result.shoppingCarts.notifications ?? []
                            }));
                        }


                        // TODO: Genauer auslesen, welche Preise sich geändert haben
                        if (r.result?.shoppingCarts.data.sum.total.grossTotal &&
                            r.result?.shoppingCarts.data.sum.total.grossTotal != sumBeforeChangeDeliveryDate &&
                            (
                                (r.result?.shoppingCarts.data.count.articles.items + r.result?.shoppingCarts.data.count.dynamicArticles.items) != countBeforeChangeDeliveryDate
                            )) {
                            this.store.dispatch(setNotification({
                                notificationType: 'info',
                                notification: 'Durch die Änderung des Lieferdatums haben sich die Artikelpreise oder Zugabeartikel geändert.'
                            }));
                        }
                    }
                );
        }
    }

    getDeliveryNotes(): string[] | null {
        return this.deliveryTourService.getDeliveryNotes();
    }

    getDeliveryTour(): ApiDeliveryTour | null {
        return this.deliveryTourService.getSelectedDeliveryTour().value;
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
    }
}
